/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ImageBrokenIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABX0lEQVR4nO2VOy8EURTHpxJKtBK+h2Ibhezuecxw55xZka1oiMpXEOPzKFgNvSDRKBQaj06BisTIjLlrdmdGYncUZG9ymvv4/+7538dxnH/TjDFjyLIHJPfIGg0SwHKHrGGslQPEA4MKYz7CHGCYnWN/kD4UZRBVGc4IgD+3SF5Krt4FuLrYJNkGktfiOXqM6C8g6w6yvhcCwPPngfWpT/yceXW6O4fFy0FIO8aYicxlWYshhY+tyUHNZgIsp41GazLuJwrqxpipRAB12UKA5bDWbo8naylgCwKWzZy4667MdCEkJ1YcXTHI+oakZ1kIku5bcXR1I7GGtGP78hax3hDJXE9GFCxlLYnPI2tZutt16/unZXKUtSxzyMmE67rXmk2BftGhxtZZCLq61SP+BTkoA0RA+gwsl4UL2YY8IsnV6CVHlX52abGo6je9/dWCA6S7JSVTw2Eyge9K5p9tH/7lu1I9UsckAAAAAElFTkSuQmCC)
 */
export const ImageBrokenIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5 2a3 3 0 0 0-3 3v4.7l3.33 3.33 3.39-3.38a1.5 1.5 0 0 1 2.12 0l3.38 3.38 3.39-3.38a1.5 1.5 0 0 1 2.12 0L22 11.92V5a3 3 0 0 0-3-3H5Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="m22 14.75-3.33-3.34-3.39 3.39a1.5 1.5 0 0 1-2.12 0L9.78 11.4 6.39 14.8a1.5 1.5 0 0 1-2.12 0L2 12.53V19a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3v-4.25Z"
        className={colorClass}
      />
    </svg>
  );
};
